<div *ngIf="show" class="strip-top">
  <div>DEV</div>
</div>